import type { Video } from 'pkg/api/models/video';
import { formatTime } from 'pkg/timeline';

export function durationTimestamp(video: Video): string {
	return formatTime(video.duration / 1000);
}
